angular.module('qkr').controller('LoyaltyCardPreviewController', ($scope, $uibModalInstance, form) => {
    const init = function() {
        $scope.form = form;
        $scope.halfMaxPoints = Math.round(form.products.qualifyingProductCount / 2);
        $scope.barFilledPercent = ($scope.halfMaxPoints / form.products.qualifyingProductCount) * 100;
        $scope.leftMarginTextPositioning = $scope.barFilledPercent - 8;
    };

    $scope.cancel = function() {
        $uibModalInstance.close('cancel');
    };

    init();
});



// WEBPACK FOOTER //
// ./src/loyalty/controllers/loyaltyCardPreview.modal.controller.js